import { BaseAdapter } from '@Modules/core/adapters/BaseAdapter';
import { IUserProfileType } from '../types/IUserProfileType';

export class UsersProfileAdapter extends BaseAdapter {
  static adapt(res: any): IUserProfileType {
    return {
      name: res?.name,
      description: res?.description,
      agence: res?.agence,
      bank: res?.bank,
    };
  }
}
